import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/apps/')({
  component: AppsIndexRedirect,
});

function AppsIndexRedirect() {
  return <Navigate to="/automations/code" replace />;
}
